import AppHeader from 'components/AppHeader';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import managerApis from 'api/managerApis';
import { AppRoutes } from 'configs/AppRoutes';
import ManagerForm from './components/form';

export default function NewManagerPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      role: 'super_admin'
    });
  }, []);

  const handleOnSubmit = async () => {
    setIsLoading(true);
    let data = form.getFieldsValue();
    try {
      const res = await managerApis.create(data);
      if (res.code == 200) {
        navigate(AppRoutes.Managers.List.path);
        message.success('Tạo thành công');
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error.message);
    }
    setIsLoading(false);
  };

  const submitForm = () => {
    form
      .validateFields()
      .then(() => {
        handleOnSubmit();
      })
      .catch((info) => {
        const errorMsg = 'Validate Failed: ' + info.errorFields[0].errors[0];
        form.scrollToField(info.errorFields[0].name, {
          behavior: 'smooth',
          block: 'center'
        });
        message.error(errorMsg);
      });
  };

  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Thêm mới Manager"
        pageHeaderExtras={[
          <Button type="primary" onClick={submitForm} loading={isLoading}>
            Tạo mới
          </Button>
        ]}
      />
      <ManagerForm
        form={form}
      />
    </>
  );
}
